module.exports = "/_next/static/images/8b65f43b0d732733edfe82fb444cee31-gift-illustration@2x.png.webp";